(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prime-collections-minimal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('prime-collections-carousel')) {
  customElements.define('prime-collections-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
    }
    initialize() {
      this.controller?.abort();
      this.observer?.disconnect();
      const track = this.querySelector('.prime-collections__track');
      const cards = Array.from(this.querySelectorAll('[data-collection-card]'));
      if (!track || !cards.length) return;
      track.classList.remove('is-dragging');
      this.controller = new AbortController();
      const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.controller.signal });
      const counter = this.querySelector('[data-current-collection]');
      const progress = this.querySelector('[data-progress-bar]');
      const previous = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');
      const navigation = this.querySelector('[data-carousel-navigation]');
      const hint = this.querySelector('.prime-collections__swipe-text');
      const rtl = getComputedStyle(track).direction === 'rtl';
      const sign = rtl ? -1 : 1;
      const maximum = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const position = () => Math.max(0, Math.min(maximum(), sign * track.scrollLeft));
      const offsets = () => {
        const first = cards[0].getBoundingClientRect();
        return cards.map(card => {
          const rect = card.getBoundingClientRect();
          return Math.min(maximum(), Math.max(0, rtl ? first.right - rect.right : rect.left - first.left));
        });
      };
      const go = value => track.scrollTo({ left: sign * value, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      const move = direction => {
        const points = offsets();
        const current = position();
        go(direction > 0 ? (points.find(point => point > current + 2) ?? maximum()) : ([...points].reverse().find(point => point < current - 2) ?? 0));
      };
      const update = () => {
        const max = maximum();
        const current = position();
        previous.disabled = current <= 2;
        next.disabled = current >= max - 2;
        navigation.hidden = max <= 2;
        if (hint) hint.hidden = max <= 2;
        if (progress) progress.style.width = `${max > 2 ? 8 + 92 * current / max : 100}%`;
        const points = offsets();
        let index = 0;
        points.forEach((point, i) => {
          if (Math.abs(point - current) < Math.abs(points[index] - current)) index = i;
        });
        if (counter) counter.textContent = String(index + 1).padStart(2, '0');
      };
      let pointer = null;
      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      let blockClick = false;
      on(track, 'pointerdown', event => {
        blockClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || maximum() <= 2) return;
        pointer = event.pointerId;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      });
      on(window, 'pointermove', event => {
        if (event.pointerId !== pointer) return;
        const distance = event.clientX - startX;
        if (!dragging && Math.abs(distance) <= 6) return;
        if (!dragging) {
          dragging = true;
          blockClick = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(pointer);
        }
        event.preventDefault();
        track.scrollLeft = startScroll - distance;
      }, { passive: false });
      const finish = event => {
        if (event.pointerId !== pointer) return;
        const id = pointer;
        const moved = dragging;
        const current = position();
        pointer = null;
        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
        if (moved) go(offsets().reduce((best, point) => Math.abs(point - current) < Math.abs(best - current) ? point : best, 0));
      };
      on(window, 'pointerup', finish);
      on(window, 'pointercancel', finish);
      on(track, 'lostpointercapture', finish);
      on(window, 'blur', () => { if (pointer !== null) finish({ pointerId: pointer }); });
      on(track, 'dragstart', event => event.preventDefault());
      on(track, 'click', event => {
        if (!blockClick || event.detail === 0) return;
        event.preventDefault();
        event.stopPropagation();
        blockClick = false;
      }, { capture: true });
      on(previous, 'click', () => move(-1));
      on(next, 'click', () => move(1));
      on(track, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') go(0);
        else if (event.key === 'End') go(maximum());
        else move((event.key === 'ArrowRight' ? 1 : -1) * sign);
      });
      on(track, 'scroll', update, { passive: true });
      on(window, 'resize', update, { passive: true });
      on(this, 'shopify:block:select', event => {
        const card = event.target.closest('[data-collection-card]');
        const index = cards.indexOf(card);
        if (index >= 0) go(offsets()[index]);
      });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        cards.forEach(card => this.observer.observe(card));
      }
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
